import { Typography } from 'antd';
import type { AdminLandingPageViewProps } from './AdminLandingPage.types';

export function AdminLandingPageView({ title }: AdminLandingPageViewProps) {
  return <Typography.Title level={2}>{title}</Typography.Title>;
}
